import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0751044"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-paymant-page" }
const _hoisted_2 = { class: "list-paymant-header" }
const _hoisted_3 = { class: "list-paymant-header-row" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "icons-row"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path1 fs-34" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path2 fs-34" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path3 fs-34" }, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "payment-items-header"
}
const _hoisted_12 = {
  class: "single-ellipsis",
  title: "Payment"
}
const _hoisted_13 = {
  class: "single-ellipsis",
  title: "Total"
}
const _hoisted_14 = {
  class: "single-ellipsis",
  title: "Local currency"
}
const _hoisted_15 = {
  class: "single-ellipsis",
  title: "Order currency"
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "list-paymant-items-block" }
const _hoisted_18 = {
  key: 0,
  style: {"border-radius":"5px","border-left":"1px solid #e4e4e4","border-right":"1px solid #e4e4e4"}
}
const _hoisted_19 = {
  key: 0,
  class: "list-paymant-items"
}
const _hoisted_20 = {
  key: 1,
  class: "list-paymant-items"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "row-item-actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-pencil fs-16 icon-color-pencil" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "circle-icon"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-pencil fs-16" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 2,
  class: "circle-icon disabled-icon"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-recycle fs-16" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-recycle fs-16" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "list-paymant-footer-actions" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "list-paymant-footer-actions" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "confirm-row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-check fs-12 pr-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.$t('cashier.label.neworder-list-payment')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.header.total-order")) + " ", 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.orderTotal / _ctx.currencyRate(_ctx.orderCurrencyId))) + " " + _toDisplayString(_ctx.currencySign(_ctx.orderCurrencyId)), 1),
          (_ctx.orderCurrencyId != _ctx.localCurrencyId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "  (" + _toDisplayString(_ctx.formatAmount(_ctx.orderTotal)) + " " + _toDisplayString(_ctx.currencySign(_ctx.localCurrencyId)) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.payments?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.groupByPayments)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon-f icon-list fs-34 d-flex dir-ltr",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.groupByPayments = !_ctx.groupByPayments))
              }, _hoisted_9))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "icon-f icon-calc fs-34",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.groupByPayments = !_ctx.groupByPayments))
              }))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10)),
    (_ctx.payments?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cashier.label.payment")), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("accounting.total")), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("cashier.label.local-currency")), 1),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("cashier.label.order-currency")), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16)),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.payments?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_ctx.groupByPayments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPayments, (payment, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-grouped-payment-item",
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.getPaymentType(index)), 1),
                      _createElementVNode("div", null, "(" + _toDisplayString(payment.length) + ")", 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.formatAmount(
        payment.reduce(
          (acc, curr) =>
            (acc += Number(curr.amount) * curr.localCurrencyRate),
          0
        )
      )) + "  ", 1),
                        _createElementVNode("div", null, _toDisplayString(_ctx.currencySign(_ctx.orderCurrencyId)), 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (payment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-paymant-item",
                      key: payment.index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.getPaymentType(payment.paymentType)), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass([payment.amount < 0 ? 'red' : ''])
                      }, _toDisplayString(_ctx.formatAmount(payment.amount)) + "  " + _toDisplayString(_ctx.currencySign(payment.currencyId)), 3),
                      _createElementVNode("div", null, [
                        (payment.currencyId != _ctx.localCurrencyId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(_ctx.formatAmount(payment.amount * payment.localCurrencyRate)) + " " + _toDisplayString(_ctx.currencySign(_ctx.localCurrencyId)) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        (payment.currencyId != _ctx.orderCurrencyId &&
      payment.currencyId != _ctx.localCurrencyId
      )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " (" + _toDisplayString(_ctx.formatAmount(
        (payment.amount * payment.localCurrencyRate) /
        _ctx.currencyRate(_ctx.orderCurrencyId)
      )) + " " + _toDisplayString(_ctx.currencySign(_ctx.orderCurrencyId)) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        (payment.documentNumber)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, " RCP " + _toDisplayString(payment.documentNumber), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        (payment.paymentType != 4 && !_ctx.isEditing && !payment.id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "circle-icon",
                              onClick: ($event: any) => (_ctx.editPayment(payment.index))
                            }, _hoisted_27, 8, _hoisted_25))
                          : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)),
                        ((payment.paymentType == 4 && payment.amount < 0) || payment.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "circle-icon",
                              onClick: ($event: any) => (_ctx.deletePayment(payment.index))
                            }, _hoisted_36, 8, _hoisted_34))
                      ])
                    ]))
                  }), 128))
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.paid")), 1),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.paid / _ctx.currencyRate(_ctx.orderCurrencyId))) + " " + _toDisplayString(_ctx.currencySign(_ctx.orderCurrencyId)) + " ", 1),
          (_ctx.orderCurrencyId != _ctx.localCurrencyId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(" + _toDisplayString(_ctx.formatAmount(_ctx.paid)) + " " + _toDisplayString(_ctx.currencySign(_ctx.localCurrencyId)) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.balance-change")), 1),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.formatAmount(_ctx.balance / _ctx.currencyRate(_ctx.orderCurrencyId))) + " " + _toDisplayString(_ctx.currencySign(_ctx.orderCurrencyId)) + " ", 1),
          (_ctx.orderCurrencyId != _ctx.localCurrencyId)
            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "(" + _toDisplayString(_ctx.formatAmount(_ctx.balance)) + " " + _toDisplayString(_ctx.currencySign(_ctx.localCurrencyId)) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      (_ctx.showSaveOrder)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SaveOrder()))
          }, [
            _hoisted_42,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.finished")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}